import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { HomeService } from 'src/app/services/home.service';
import * as $ from 'jquery'
@Component({
  selector: 'app-headersearch',
  templateUrl: './headersearch.component.html',
  styleUrls: ['./headersearch.component.css']
})
export class HeadersearchComponent implements OnInit {
  showotp: boolean = false;
  showotp_user: boolean = false
  showotp_user_login: boolean = false
  showpass: boolean = false
  showpass_user: boolean = false
  loginhide: boolean = false

  loginData: any = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('logindata')) : {}
  phoneNo: string = ''
  phoneNo_user: string = ''
  checkOtp: any
  checkOtp_user: any = {
    data: '',
    otp: 0
  }
  errorOtpMessage: string = ''
  errorOtpUserMessage: string = ''
  errorOtp: boolean = false
  errorOtp_user: boolean = false
  errorPass: boolean = false
  verifyOtpError: boolean = false
  verifyOtpError_user: boolean = false
  verifyPassError: boolean = false
  verifyPassError_user: boolean = false
  isLoggedin: boolean = false

  otpValObjUser1: String
  otpValObjUser2: String
  otpValObjUser3: String
  otpValObjUser4: String
  otpValObj1: String
  otpValObj2: String
  otpValObj3: String
  otpValObj4: String
  Pass: string
  Pass_user: string

  @Input('partner') partner: boolean

  countryCode_user: string = '91'
  countryCode: string = '91'

  otpVal_user: String
  type: string = localStorage.getItem('usertype')  // possible values Hospital,Ambulance,Doctor,Lab,Pharmecy,User
  type2: any;
  type1: any;
  type3: any;
  type4: any;
  cities: any = []
  bookingDoctorInfo: any = {
    rating: 0,
    review: 0,
    profilePicture: 'https://digitalmenulist.s3.ap-south-1.amazonaws.com/profilePic_1571915073215.jpeg',
    name: 'Test'

  }
  showEye: boolean = true
  showEyeUser: boolean = true
  showList: boolean = false

  isLoggedIn: boolean = !!localStorage.getItem('token')
  sessionStoreURL = localStorage.getItem('sesssionUrl')

  constructor(
    private auth: AuthService,
    private route: Router,
    private toaster: ToastrService,

  ) {
    if (this.sessionStoreURL && this.isLoggedIn) {
      this.route.navigate([`/${this.sessionStoreURL}`])
    }

  }

  ngOnInit() {
    localStorage.removeItem('pharmacyIdBook')
    localStorage.removeItem('pharmacyBookingData')
    this.isLoggedin = this.auth.isLoggedin
    //this.getCities()
    this.getLocation()
  }
  getLocation() {
    this.auth.getLocation().then(location => {
      if (!location.nolocation) {
        localStorage.setItem('lat', location.lat)
        localStorage.setItem('lng', location.lng)
      }
      else {
        localStorage.setItem('lat', '30.7333')
        localStorage.setItem('lng', '76.7794')

      }



    })
  }
  // getCities(){
  //   this.homeSvc.getCities().subscribe(res=>{
  //     this.cities = res["data"]
  //     },error=>{

  //     })
  // }

  onCountryChange(event) {
    this.countryCode_user = event.dialCode
  }
  onCountryChangePartner(event) {
    this.countryCode = event.dialCode
  }
  hasError(event) {

  }
  checkPassfunc_user() {
    this.auth.checkPassfunc_user(this.phoneNo_user, this.Pass_user, 'User', this.countryCode_user).subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyPassError_user = false
        this.showpass_user = false
        document.getElementById("logintoggle_user").click();
        this.loginData = JSON.parse(localStorage.getItem('logindata'))
        //     localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)

        this.isLoggedin = true

        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });

        let labBookingData = JSON.parse(localStorage.getItem('labBookingData'))
        if (labBookingData != null) {

          document.getElementById('address_lab').click()

        }

        let pharmacyBookingID = localStorage.getItem('pharmacyIdBook')
        let pharmacyBookingData = JSON.parse(localStorage.getItem('pharmacyBookingData'))
        if (pharmacyBookingID != null) {

          document.getElementById('address_pharmacy').click()
        }
        let doctorBookingData = JSON.parse(localStorage.getItem('doctorBookingData'))
        if (doctorBookingData != null) {
          this.bookingDoctorInfo = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('doctorBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }
        let hospitalBookingData = JSON.parse(localStorage.getItem('hospitalBookingData'))
        if (hospitalBookingData != null) {
          //  this.bookingDoctorInfo  = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('hospitalBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }


      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      console.log(error)
      this.verifyPassError_user = true
    })
  }
  EnterOtp(event: NgForm) {
    if (event.submitted && event.valid) {
      this.auth.getOtp(this.phoneNo, this.type, this.countryCode).subscribe((res: any) => {
        console.log(res)
        if (res.statusCode == 200) {
          this.checkOtp = res.data;
          this.loginhide = true
          if (this.checkOtp.passwordSet) {

            this.showpass = true
          }
          else {
            this.showotp = true
            this.errorOtp = false
          }

        } else {
          this.errorOtp = true
          this.errorPass = true

        }
      },
        error => {
          this.errorOtp = true
          this.errorPass = true
          this.errorOtpMessage = error.error.message
        }
      )

    }
  }

  setVal(val) {
    console.log('am changed');
    this.type = val;
  }

  removeChecked() {

  }
  resendOtpUser() {
    this.auth.getOtp(this.phoneNo_user, 'User', this.countryCode_user).subscribe((res: any) => {
      console.log(res)
      if (res.statusCode == 200) {
        // this.showotp_user = true

        this.errorOtp_user = false
        this.checkOtp_user = res.data;



        this.showotp_user = true
        this.errorOtp_user = false
        this.showpass_user = false
        this.showotp_user_login = true

        this.toaster.success('Otp Sent...', '', {
          timeOut: 2000
        });

      } else {
        //  this.errorOtpUserMessage = "There was some error sending the Otp..."
        this.errorOtp_user = true

      }
    },
      error => {
        this.toaster.error('There was some errro sending the Otp...', '', {
          timeOut: 2000
        });
        this.errorOtpUserMessage = error.error.message
        this.errorOtp_user = true
      }
    )
  }

  resendOtp() {

    this.auth.getOtp(this.phoneNo, this.type, this.countryCode).subscribe((res: any) => {
      console.log(res)
      if (res.statusCode == 200) {
        this.showotp = true
        this.errorOtp = false
        this.toaster.success('Otp Sent...', '', {
          timeOut: 2000
        });
        this.checkOtp = res.data;
      } else {
        this.toaster.success('There was some errro sending the Otp...', '', {
          timeOut: 2000
        });
        this.errorOtp = true

      }
    },
      error => {
        this.errorOtp = true
      }
    )


  }

  EnterOtp_user() {
    if (this.phoneNo_user.length != 10) {
      this.errorOtp_user = true
      this.errorOtpUserMessage = 'Phone Number should be of 10 digits...'
    }
    else {
      this.auth.getOtp(this.phoneNo_user, 'User', this.countryCode_user).subscribe((res: any) => {
        console.log(res)
        if (res.statusCode == 200) {
          // this.showotp_user = true

          this.errorOtp_user = false
          this.checkOtp_user = res.data;

          if (this.checkOtp_user.otp == 1) {
            console.log(this.checkOtp_user.otp)
            this.showpass_user = true
            this.showotp_user_login = true

          }
          else {
            this.showotp_user = true
            this.errorOtp_user = false
            this.showpass_user = false
            this.showotp_user_login = true
          }
        } else {
          this.errorOtp_user = true

        }
      },
        error => {
          this.errorOtpUserMessage = error.error.message
          this.errorOtp_user = true
        }
      )

    }
  }

  checkOtpfunc() {
    let otp_val = this.otpValObj1 + '' + this.otpValObj2 + '' + this.otpValObj3 + '' + this.otpValObj4
    console.log(otp_val)
    this.auth.checkOtpfunc(this.phoneNo, otp_val, this.type).subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyOtpError = false
        this.showotp = false
        document.getElementById("logintoggle").click();
        let profileUpdated = JSON.parse(localStorage.getItem('logindata'))['profileUpdated']
        localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)
        console.log(profileUpdated)
        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });
        if (!profileUpdated) {
          console.log('profile')
          this.route.navigate([`/${this.type}/profile-edit`])
        } else {
          console.log('dashboard')
          this.route.navigate([`/${this.type}/dashboard`])
        }

      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      this.verifyOtpError = true
    })
  }
  checkPassfunc() {

    this.auth.checkPassfunc(this.phoneNo, this.Pass, this.type, this.countryCode).subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyPassError = false
        this.showpass = false
        document.getElementById("logintoggle").click();
        let profileUpdated = JSON.parse(localStorage.getItem('logindata'))['profileUpdated']
        localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)
        console.log(profileUpdated)
        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });
        if (!profileUpdated) {
          console.log('profile')
          this.route.navigate([`/${this.type}/profile-edit`])
        } else {
          console.log('dashboard')
          this.route.navigate([`/${this.type}/dashboard`])
        }

      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      console.log(error)
      this.verifyPassError = true
    })
  }
  loginUser() {
    this.phoneNo_user = ''
    this.otpValObjUser1 = ''
    this.otpValObjUser2 = ''
    this.otpValObjUser3 = ''
    this.otpValObjUser4 = ''
    this.showotp_user_login = false
    this.showotp_user = false
    this.showpass_user = false
    this.Pass_user = ''
    this.errorOtpUserMessage = ''
    this.verifyOtpError_user = false
    this.errorOtp_user = false
  }
  forgotPass() {
    this.auth.forgotPass(this.phoneNo, this.type, this.countryCode).subscribe(res => {
      this.toaster.success('Please check your phone for Password...', '', {
        timeOut: 2000
      });
    }, error => {
      this.toaster.success('There was some error sending the password...', '', {
        timeOut: 2000
      });
    })
  }
  forgotPassUser() {
    this.auth.forgotPassUser(this.phoneNo_user, this.countryCode_user).subscribe(res => {
      this.toaster.success('Please check your phone for Password...', '', {
        timeOut: 2000
      });
    }, error => {
      this.toaster.success('There was some error sending the password...', '', {
        timeOut: 2000
      });
    })
  }
  checkOtpfunc_user() {
    let otp_val = this.otpValObjUser1 + '' + this.otpValObjUser2 + '' + this.otpValObjUser3 + '' + this.otpValObjUser4
    this.auth.checkOtpfunc(this.phoneNo_user, otp_val, 'User').subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyOtpError_user = false
        this.showotp_user = false
        this.isLoggedin = true
        this.loginData = JSON.parse(localStorage.getItem('logindata'))
        document.getElementById("logintoggle_user").click();



        let doctorBookingData = JSON.parse(localStorage.getItem('doctorBookingData'))
        let hospitalBookingData = JSON.parse(localStorage.getItem('hospitalBookingData'))
        let labBookingData = JSON.parse(localStorage.getItem('labBookingData'))
        let pharmacyBookingID = localStorage.getItem('pharmacyIdBook')
        let pharmacyBookingData = JSON.parse(localStorage.getItem('pharmacyBookingData'))


        if (!this.loginData.passwordSet) {

          if (doctorBookingData != null) {
            localStorage.removeItem('doctorBookingData')
          }
          else if (hospitalBookingData != null) {
            localStorage.removeItem('hospitalBookingData')
          }
          else if (labBookingData != null) {
            localStorage.removeItem('labBookingData')
          }
          else if (pharmacyBookingID != null) {
            localStorage.removeItem('pharmacyIdBook')
            localStorage.removeItem('pharmacyBookingData')
          }
          else {
            document.getElementById('passwordResetbutton').click()
          }
        }

        if (labBookingData != null) {

          document.getElementById('address_lab').click()

        }


        if (pharmacyBookingID != null) {

          document.getElementById('address_pharmacy').click()
        }

        if (doctorBookingData != null) {
          this.bookingDoctorInfo = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('doctorBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }

        if (hospitalBookingData != null) {
          //  this.bookingDoctorInfo  = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('hospitalBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }
        //this.route.navigate([`user-profile`])
      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      this.verifyOtpError_user = true
    })
  }

  logout() {
    this.auth.logout()
    this.isLoggedin = false
    this.showList = false
    this.route.navigate(['/'])

  }

  numberOnly(event, id): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (id != null) {
      setTimeout(function () { document.getElementById(id).focus() }, 100);
    }
    return true;

  }
  numberOnlyBack(event, id, id1): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 37) {
      document.getElementById(id).focus()
      return false
    }
    if (charCode == 39) {
      document.getElementById(id1).focus()
      return false
    }
    if (charCode == 8) {
      event.target.value = ''
      document.getElementById(id).focus()
    }
    // if (id != null)
    //     document.getElementById(id).focus()

    return true;
  }

}
